const sortDirections = [
    'ASC',
    'DESC',
];

export default sortDirections;
